export enum UIStyleConstants {
  PRIMARY_COLOR = "#038fde",
  SECONDARY_COLOR = "#fa8c15"
}
